import { Component, Input } from '@angular/core';
import { Project, PROJECT_URGENCY_OBJECT } from '@data/models/project.model';
import { Period, ServiceLevel } from '@data/models/sla-period.model';
import { PERIOD_24X7 } from '@modules/projects/components/project-wizard-sla/project-wizard-sla.component';

@Component({
    selector: 'syn-sla-service-level',
    templateUrl: 'sla-service-level.component.html',
    styleUrls: ['sla-service-level.component.scss']
})
export class SlaServiceLevelComponent {

    @Input() serviceLevelId: string;
    @Input() project: Project;
    @Input() periods: Period[];

    public getServiceLevel(): ServiceLevel | undefined {
        return this.project?.serviceLevels?.find(sl => sl.id === this.serviceLevelId);
    }

    public getName(serviceLevel: ServiceLevel): string {
        const criticity = PROJECT_URGENCY_OBJECT[serviceLevel.urgency].translate;
        const time = serviceLevel.period === PERIOD_24X7 ? '24x7' : 'HO';
        return `${criticity} ${time}`;
    }

    public getPeriodName(serviceLevel: ServiceLevel): string {
        return this.periods?.find(period => period.id === serviceLevel.period)?.name;
    }
}
